import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const sendOtoIndividualEnrollmentsToHostFamily = (input: IdsInput) => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendOtoIndividualEnrollmentsToHostFamily.url, null))
    .post(input)
}
